import { capitalize } from '~/assets/utils/string';

export default function ({ name, categoryName }) {
    return `${capitalize(name)} - ${capitalize(categoryName)} - Castorama`;
}
